import eventTracker from '../eventTracker/eventTracker';
import helper from '../eventTracker/helper';
import { selectIsFullScreen, selectPlayerParams, useSelector } from '../redux';
import useMetaData from './video-player/useMetaData';

const useEventTracker = () => {
  const isFullScreen = useSelector(selectIsFullScreen);
  const { scheduleDetails, batchDetails } = useMetaData();
  const { subjectSlug } = useSelector(selectPlayerParams);

  const handleVideoPlayerFeature = (featureName: string, source = '') => {
    const data = {
      class_type: scheduleDetails?.videoDetails && scheduleDetails?.isLive ? 'live' : 'recorded',
      screen_type: isFullScreen ? 'full' : 'semi_full',
      feature_name: featureName,
      video_id: scheduleDetails?.videoDetails?._id,
      schedule_id: scheduleDetails?._id,
      batch_id: batchDetails?._id,
      UserPhoneNumber: helper.userInfodata().primaryNumber,
      ...(source ? { source } : {}),
    };
    eventTracker.videoPlayerFeature(data);
  };

  const handleMQTTConnectionStatus = (state: string, scheduleId: string) => {
    const data = {
      connect_state: state,
      screen_type: isFullScreen ? 'full' : 'semi_full',
      schedule_id: scheduleId,
      UserPhoneNumber: helper.userInfodata().primaryNumber,
    };
    eventTracker.mqttConnectionState(data);
  };

  const handleUSocketConnectionState = (
    state: string,
    scheduleId: string,
    connectionId?: string,
  ) => {
    const data = {
      socket_connection_state: state,
      screen_type: isFullScreen ? 'full' : 'semi_full',
      schedule_id: scheduleId,
      UserPhoneNumber: helper.userInfodata().primaryNumber,
      socket_connection_id: connectionId,
    };
    eventTracker.uSocketConnectionState(data);
  };

  const liveClassjoined = (data: {
    scheduleId: string;
    batchId: string;
    startTime: string;
    urlType: string;
  }) => {
    const dataForEvent: {
      scheduleId: string;
      batchId: string;
      subjectId: string;
      video_type: string;
      video_start_time: string;
      student_joined_time: number;
      player_type: string;
    } = {
      scheduleId: data.scheduleId || '',
      batchId: data.batchId || '',
      subjectId: subjectSlug || '',
      video_type: data.urlType,
      video_start_time: data.startTime,
      student_joined_time: Math.floor(new Date().getTime() / 1000),
      player_type: 'new',
    };
    eventTracker.liveClassJoined(dataForEvent);
  };
  const liveClassleft = (data: {
    scheduleId: string;
    batchId: string;
    startTime: string;
    urlType: string;
    subjectId: string;
  }) => {
    const dataForEvent: {
      scheduleId: string;
      batchId: string;
      subjectId: string;
      video_type: string;
      video_start_time: string;
      student_left_time: number;
      player_type: string;
    } = {
      scheduleId: data.scheduleId || '',
      batchId: data.batchId || '',
      subjectId: data.subjectId || '',
      video_type: data?.urlType,
      video_start_time: data.startTime,
      student_left_time: Math.floor(new Date().getTime() / 1000),
      player_type: 'new',
    };
    eventTracker.liveClassLeft(dataForEvent);
  };

  const pollIconClicked = (data: {
    activePollId: string;
    poll_start_time: number;
    socket_status: string;
    schedule_id: string;
    connection_id: string;
  }) => {
    const dataForEvent = {
      poll_id: data.activePollId || '',
      schedule_id: data.schedule_id || '',
      received_time: Math.round(new Date().getTime() / 1000),
      start_time: data.poll_start_time,
      player_type: 'new',
      socket_status: data.socket_status,
      socket_connection_id: data.connection_id,
    };
    eventTracker.pollIconClicked(dataForEvent);
  };

  const streamingStarted = () => {
    const dataForEvent: {
      video_id: string;
      batch_name: string;
      schedule_id: string;
      schedule_start_time: string;
      off_time: any;
    } = {
      video_id: scheduleDetails.videoDetails._id,
      batch_name: batchDetails?.name,
      schedule_id: scheduleDetails._id,
      schedule_start_time: scheduleDetails.startTime,
      off_time: new Date().getTime() / 1000,
    };
    eventTracker.streamingStarted(dataForEvent);
  };

  const scheduleUpdate = (updatedTime: any) => {
    const dataForEvent: {
      video_id: string;
      batch_name: string;

      schedule_id: string;
      schedule_start_time: string;
      schedule_update_time: any;
    } = {
      video_id: scheduleDetails?.videoDetails?._id || 'NA',
      batch_name: batchDetails?.name,
      schedule_id: scheduleDetails._id,
      schedule_start_time: scheduleDetails.startTime,
      schedule_update_time: updatedTime,
    };
    eventTracker.scheduleUpdate(dataForEvent);
  };
  return {
    handleVideoPlayerFeature,
    handleMQTTConnectionStatus,
    liveClassjoined,
    liveClassleft,
    pollIconClicked,
    streamingStarted,
    scheduleUpdate,
    handleUSocketConnectionState,
  };
};

export default useEventTracker;
